import api from './api';

const carnetCommandeApi = {
  getAll: (params) => api.get('/carnet-commande', { params }),
  sync:   ()       => api.post('/carnet-commande/sync'),
  getByOr: (numOr) => api.get(`/carnet-commande/by-or/${encodeURIComponent(numOr)}`),
  // Anomalies
  createAnomalie:  (data)              => api.post('/carnet-commande/anomalies', data),
  updateAnomalie:  (id, data)          => api.patch(`/carnet-commande/anomalies/${id}`, data),
  resolveAnomalie: (id, data)          => api.patch(`/carnet-commande/anomalies/${id}/resolve`, data),
  deleteAnomalie:  (id)                => api.delete(`/carnet-commande/anomalies/${id}`),
  // Stock magasin : retourne pour chaque ref { concession_stock, other_concessions[] }
  lookupStock: (refs, concessionId) => api.get('/stock-pieces/lookup', {
    params: { refs: Array.isArray(refs) ? refs.join(',') : refs, concession_id: concessionId || undefined },
  }),
};

export default carnetCommandeApi;
